import React, { useEffect, useState } from 'react';
import './Signup.css';
import ServiceBus from '../services/ServiceBus.ts';
import { backend } from '../constants/constants.js';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { FloatLabel } from 'primereact/floatlabel';

function Signup() {
  useEffect(() => {
    document.body.style.backgroundColor = '#e4e4e4';
  });
  const serviceBus = new ServiceBus();
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [pass2, setPass2] = useState('');
  function updateUser(e) {
    setUser(e.target.value);
  }
  function updatePass(e) {
    setPass(e.target.value);
  }
  function doSignup() {
    if (pass2 === pass) {
      serviceBus
        .signup(user, pass)
        .then((res) => {
          //serviceBus.saveToken(res['access_token']);
          //window.location.replace('/lab/access');
        })
        .catch(() => {});
    }
  }

  return (
    <>
      <div className={'signup-form'}>
        <img alt="logo" className={'logo-image'} src={backend + 'logo'} />
        <br />
        {/* <label className={'username-label'}>Username:</label>
        <br />
        <br />
        <input
          className={'username-field'}
          type="text"
          value={user}
          onChange={updateUser}
        /> */}
        <div className={'signupLabelContainer'}>
          <FloatLabel>
            <InputText value={user} onChange={(e) => setUser(e.target.value)} />
            <label className={'signupLabel'}>Username</label>
          </FloatLabel>
        </div>
        <br />
        <br />
        <div className={'signupLabelContainer'}>
          <FloatLabel>
            <InputText
              type="password"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
            />
            <label className={'signupLabel'}>Password</label>
          </FloatLabel>
        </div>
        <br />
        <br />
        <div className={'signupLabelContainer'}>
          <FloatLabel>
            <InputText
              type="password"
              value={pass2}
              onChange={(e) => setPass2(e.target.value)}
            />
            <label className={'signupLabel'}>Confirm Password</label>
          </FloatLabel>
        </div>
        {/* <label className={'password-label'}>Password:</label>
        <br />
        <br />
        <input
          className={'password-field'}
          type="password"
          value={pass}
          onChange={updatePass}
        />
        <br /> */}
        <button className={'signup-button'} onClick={doSignup}>
          Sign up
        </button>
      </div>
    </>
  );
}
export default Signup;
